"use client";

import type { SettingsQueryResult } from "@lib/types";
import { createContext, useContext } from "react";

export type SiteData = {
  settings: SettingsQueryResult;
  // Future: config?: SiteConfig | null;
  // Future: theme?: ThemeConfig | null;
};

const SiteDataContext = createContext<SiteData | null>(null);

export function SiteDataProviderClient({
  siteData,
  children,
}: {
  siteData: SiteData;
  children: React.ReactNode;
}) {
  return <SiteDataContext.Provider value={siteData}>{children}</SiteDataContext.Provider>;
}

export function useSiteData(): SiteData | null {
  return useContext(SiteDataContext);
}

export function useSettings(): SettingsQueryResult {
  const siteData = useSiteData();
  return siteData?.settings ?? null;
}
